import { vndHlp, vndRgtEvts, vndSch, PageRender, vndTopbar, vndHeader, vndMbHd, slideShow, parallaxLookbook, groupContent, vndSectionSlider, vndIstSection, lookbookSection, vndPkrSt, vndMsrGrd, vndPageTabs, vndServicePromotion, vndSectionImage2 } from "//www.framesplus.co.uk/cdn/shop/t/79/assets/theme.js?v=149296324185191006391789122568";

document.addEventListener('DOMContentLoaded', function() {
  let vndEvts = new vndRgtEvts();
  window.vndTheme.scroll_width = window.innerWidth - document.body.clientWidth;

  vndHlp.initSct(null, '[id^="shopify-section-"][id$="__top-bar"]', vndTopbar.onLoad);
  vndHlp.initSct(null, '[id^="shopify-section-"][id$="__header"]', vndHeader.onLoad);
  vndHlp.initSct(null, '[id^="shopify-section-"][id$="__header-mobile"]', vndMbHd.onLoad);
  vndHlp.initSct(null, 'section.vs-homepage-slideshow', slideShow.onLoad);
  vndHlp.initSct(null, 'section.vs-parallax-lookbook', parallaxLookbook.onLoad);
  vndHlp.initSct(null, 'section.vs-group-content', groupContent.onLoad);
  vndHlp.initSct(null, 'section.vs-initialize-slider', vndSectionSlider.onLoad);
  vndHlp.initSct(null, 'section.vs-collections-tab', vndIstSection.onLoad);
  vndHlp.initSct(null, 'section.vs-lookbook', lookbookSection.onLoad);
  vndHlp.initSct(null, 'section.vs-packery', vndPkrSt.onLoad);
  vndHlp.initSct(null, 'section.vs-masonry-grid', vndMsrGrd.onLoad);
  vndHlp.initSct(null, 'section.vs-page-tabs', vndPageTabs.onLoad);
  vndHlp.initSct(null, '.vs-service-promotion', vndServicePromotion.onLoad);
  vndHlp.initSct(null, '.vs-image-2', vndSectionImage2.onLoad);

  PageRender.init();

  vndSch();
});
